<ng-container [caLocalizationScope]="localizationKey">
  <div
    class="badge badge-icon badge-success-secondary rounded-pill mx-0"
    title="{{ tooltipText | caLocalize }}"
    triggers="hover focus"
    container="body"
    placement="bottom auto"
    [ngClass]="[badgeSize, rootCssClass]"
  >
    <i class="f-i f-i-ESG"></i>
  </div>
</ng-container>
